import numeral from "numeral"
const formatNumber ={}

function format(number,format)
{
    return numeral(number).format(format)
}

formatNumber.install = (Vue) => 
{
    Vue.filter('formatNumber', (val,formato) => {
        return format(val,formato) })
}

export default formatNumber
